import React from 'react'
import Img from 'gatsby-image'
import MediaQuery from 'react-responsive'

// Import styled components
import {
  Wrapper,
  ImageListWrapper,
  TitleWrapper,
  MainImageWrapper,
  DescWrapper,
  TeamDescription,
  TeamTitle,
  ImageWrapper,
  ContentWrapper,
  TeamImageWrapper
} from './TeamResponsive'

// Import common components
import { FlexBox, Box } from '../../common/Box'
import { Col6, Col12 } from '../../common/Grid'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'
import TYPOGRAPHY from '../../../themes/Typography'

// List text of title
const data = [
  {
    type: 'medium',
    text: 'The team',
    style: {
      textTransform: 'capitalize'
    }
  },
  {
    type: 'medium',
    text: 'Passionate',
    style: {
      textTransform: 'uppercase',
      lineHeight: px2Rem(43)
    }
  },
  {
    type: 'medium',
    text: 'In all things',
    style: {
      fontSize: px2Rem(33),
      textTransform: 'capitalize',
      lineHeight: px2Rem(38)
    }
  },
  {
    type: 'medium',
    text: 'Gaming',
    style: {
      fontSize: px2Rem(47),
      textTransform: 'uppercase',
      fontFamily: TYPOGRAPHY.TYPE.bold,
      lineHeight: px2Rem(49)
    }
  }
]

const MainTitle = () => (
  <Box textAlign='right'>
    {
      data && data.map((title, index) => (
        <TeamTitle
          key={index}
          type={title.type}
          title={title.text}
          style={title.style}
        />
      ))
    }
  </Box>
)

const MainTitleMobile = () => (
  <TeamTitle
    type='xSmall'
    title='A team passionate in all things gaming'
    lineHeight='1.5'
  />
)

/**
 * Render main section of team
 * @param {object} images
 */
const renderMainSection = (matches, team) => {
  return (
    <FlexBox flexWrap='wrap'>
      <TitleWrapper>
        {matches ? <MainTitleMobile /> : <MainTitle />}
      </TitleWrapper>
      <MainImageWrapper>
        <Img
          sizes={team.sizes}
          style={{height: '100%'}}
          imgStyle={{objectPosition: 'top'}}
        />
      </MainImageWrapper>
    </FlexBox>
  )
}

// Render description team section
const renderDescription = (matches) => {
  return (
    <DescWrapper>
      <FlexBox
        height='100%'
        alignItems='center'
        bgColor={COLORS.gray}
      >
        <TeamDescription
          type={matches ? 'xxTiny' : 'tiny'}
          text={`Over the years, we have worked with the industry’s top entertainment companies to create over 50+ games based on leading brands as well as original IPs across all major platforms. Today, our four business units continue to create console, mobile and web-based interactive experiences featuring the world’s coolest characters and most engaging stories.`}
        />
      </FlexBox>
    </DescWrapper>
  )
}

/**
 * Render team images list
 */
const renderImageList = (teamDesign, teamGame) => (
  <ImageListWrapper>
    <TeamImageWrapper>
      <Wrapper>
        <Img
          sizes={teamDesign.sizes}
          style={{height: '100%'}}
        />
      </Wrapper>
      <Wrapper>
        <Img
          sizes={teamGame.sizes}
          style={{height: '100%'}}
        />
      </Wrapper>
    </TeamImageWrapper>
  </ImageListWrapper>
)

/**
 * Render team images list on mobile
 */
const renderImageListMobile = (imageList) => {
  return (
    <Col12>
      <FlexBox overflow='scroll'>
        {imageList && imageList.map((image, index) => (
          <ImageWrapper key={index} margin='0 1px'>
            <Img
              sizes={image.sizes}
              style={{height: '100%'}}
            />
          </ImageWrapper>
        ))}
      </FlexBox>
    </Col12>
  )
}

// Team component
const Team = ({ id, team, teamDesign, teamGame, aboutUsDesign, aboutUsGame }) => (
  <MediaQuery maxWidth={767}>
    {(matches) => {
      return (
        <Box bgColor={COLORS.white} id={id}>
          {/* Top section with main title and main image of team */}
          {renderMainSection(matches, team)}

          {/* Bottom row with description and two images */}
          <ContentWrapper>
            {renderDescription(matches)}
            {matches ?
              renderImageListMobile([teamDesign, aboutUsGame, aboutUsDesign, teamGame]) :
              renderImageList(teamDesign, teamGame)
            }
          </ContentWrapper>
        </Box>
      )
    }}
  </MediaQuery>
)

export default Team



// WEBPACK FOOTER //
// ./src/components/sections/team/Team.js